import { PropsWithChildren } from 'react';
import { NotificationsContext } from '@/src/features/app/store/notifications/context';
import { useNotificationsStore } from '@/src/features/app/store/notifications/store';

export const NotificationsContextProvider = ({ children }: PropsWithChildren) => {
  const store = useNotificationsStore();

  return (
    <NotificationsContext.Provider value={store}>
      {children}
    </NotificationsContext.Provider>
  );
};
